export const waitForTurnstile = async ({
  timeoutMs = 2000,
  intervalMs = 50,
} = {}) => {
  const startedAt = Date.now()

  while (Date.now() - startedAt < timeoutMs) {
    if (typeof window !== "undefined" && window.turnstile) {
      return
    }
    await new Promise((resolve) => setTimeout(resolve, intervalMs))
  }

  throw new Error("Turnstile did not initialize in time")
}

export const loadTurnstileScript = async ({ scriptSrc }) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return
  }
  if (window.turnstile) {
    return
  }

  await new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${scriptSrc}"]`)
    if (existing) {
      if (window.turnstile) {
        resolve()
        return
      }
      existing.addEventListener("load", resolve, { once: true })
      existing.addEventListener("error", reject, { once: true })
      return
    }

    const script = document.createElement("script")
    script.src = scriptSrc
    script.async = false
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}
